// extracted by mini-css-extract-plugin
export var modal = "_bn-0";